import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=a8e7a188&scoped=true&"
import script from "./Statistic.vue?vue&type=script&lang=ts&"
export * from "./Statistic.vue?vue&type=script&lang=ts&"
import style0 from "./Statistic.vue?vue&type=style&index=0&id=a8e7a188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e7a188",
  null
  
)

export default component.exports